/**
 * NLB-GW
 *
 * Contact: service@rheinenergie.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * data object for defer payment call
 */
export interface DeferPaymentData { 
    /**
     * identifies a payment item
     */
    id?: string;
    /**
     * accountId of existing contract, also knows as VK
     */
    accountId?: string;
    deferredTo?: Date;
}

